"use strict";

import axios from "axios";
import { Message } from "element-ui";
import store from "../store";
import { getToken } from "@/utils/auth";
import { MessageBox } from "element-ui";
import { tirm } from "@/utils/object";
import { isEmpty } from "validate.js";

// 创建axios实例
const service2 = axios.create({
  baseURL: process.env.BASE_SERVICE_API, // api的base_url
  withCredentials: true, // zym.send cookies when cross-domain request
  // timeout: 72000000 // 请求超时时间
  timeout: 20 * 60 * 1000, // 请求超时时间
});

// request拦截器
service2.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      // config.headers['X-Token'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers["Authorization"] = `Bearer ${getToken()}`;
    }

    var param = tirm(config.data);
    config.data = param;
    // config['data1']= param;
    console.debug(config.url, config.data);
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service2.interceptors.response.use(
  (response) => {
    // console.debug('rep: ', response.data.data)
    /**
     * code大于0抛错
     */
    const res = response.data;
    // const payload = res.payload
    // if(payload.resultStatus&&payload.resultStatus.status>0){
    //     console.log(res.payload.resultStatus.status)
    if (res.code && res.code !== 0) {
      console.warn("返回异常: ", res.code, res);
      Message({
        message: res.message || res.error,
        type: "error",
        duration: 5 * 1000,
      });
      // 画面sonomama 不想统一处理
      return Promise.resolve(res);
      // 130033:非法的token; 130033:其他客户端登录了;  130033:Token 过期了;
      // if (res.payload.resultStatus.status === 130033) {
      //     MessageBox.alert('你已被登出，请重新登录，如非本人操作请修改密码', '提示', {
      //         confirmButtonText: '重新登录',
      //         callback: action => {
      //             store.dispatch('FedLogOut').then(() => {
      //                 location.reload();// 为了重新实例化vue-router对象 避免bug
      //             });
      //         }
      //     });
      // }else{
      //     Message({
      //         message: payload.resultStatus.message,
      //         type: 'error',
      //         duration: 5 * 1000
      //     });
      // }
      // return Promise.reject('error');
    } else {
      //HYY 修改
      if (res instanceof Blob) {
        var content = response.headers["content-disposition"];
        var filename = "文件名称";
        if (!isEmpty(content)) {
          var arr = content.split("=");
          if (arr.length > 1) {
            filename = arr[1];
          }
        }
        localStorage.setItem("dfilename", filename);
        return Promise.resolve(res);
      } else {
        return Promise.resolve(res.data);
      }
    }
  },
  (error) => {
    console.log("err:", error); // for debug
    const { data, status, statusText } = error.response;
    var message = "";
    if (error.message === "Network Error") {
      message = "网络异常";
    } else if (error.message === "timeout of 200000ms exceeded") {
      message = "请求服务器超时，请重试";
    } else {
      message = error.message;
    }
    if (status && status === 401) message = "认证已经过期，请尝试退出并重新登录。";
    Message({
      message: message,
      type: "error",
      duration: 5 * 1000,
    });
    // var message = '网络异常'
    // if(error==='Error: Network Error'){
    //     message = '网络异常'
    // }
    return Promise.reject(error);
  }
);

export default service2;



// WEBPACK FOOTER //
// ./src/utils/fetch2.js